import React from "react";

export default function Blog2() {
  return (
    <div
      style={{
        padding: "60px 20px",
        maxWidth: "900px",
        margin: "0 auto",
        lineHeight: "1.8",
        color: "#222",
      }}
    >
      <h1
        style={{
          fontSize: "42px",
          marginBottom: "20px",
          fontWeight: "bold",
          lineHeight: "1.3",
        }}
      >
        Scan Documents Offline and How to Generate QR Code  
      </h1>

      <meta
  name="description"
  content="Scan documents to PDF offline, generate QR codes, edit PDFs, add watermarks, convert images to PDF, and organize files with Dox Scanner."
/>

<meta
  name="keywords"
  content="pdf scanner, document scanner, qr generator, generate qr code, free qr code generator, pdf editor, image to pdf, pdf watermark, watermark pdf, remove watermark, scan documents to pdf, offline pdf scanner, ocr scanner"
/>

    <p style={styles.paragraph}>
Scanning documents to PDF on iPhone and Android has become an essential task
for students, professionals, freelancers, and businesses. Whether you need a
PDF Scanner, Document Scanner, Image to PDF Converter, QR Generator, PDF
Editor, or OCR Scanner, having the right app can help you manage documents
quickly and securely.
</p>

      <p style={styles.paragraph}>
        Many users today prefer offline PDF scanner apps because they offer
        better privacy, faster performance, and no dependency on internet
        connectivity. In this guide, we will explain how to scan documents to
        PDF offline on iPhone using Dox Scanner.
      </p>

      <div style={styles.imageContainer}>
        <img
          src="/screenshot1.png"
          alt="Scan documents to PDF on iPhone"
          style={styles.image}
        />
      </div>

      <h2 style={styles.heading}>Step 1 — Open Dox Scanner</h2>

      <p style={styles.paragraph}>
        Download and open Dox Scanner on your iPhone. The app provides a clean
        and simple interface designed for fast document scanning and PDF
        management.
      </p>

      <p style={styles.paragraph}>
        Once the app opens, tap the scan button to start capturing your
        document.
      </p>

      <h2 style={styles.heading}>Step 2 — Capture Your Document</h2>

      <p style={styles.paragraph}>
        Place your document on a flat surface with proper lighting. Use your
        iPhone camera to capture the page clearly.
      </p>

      <p style={styles.paragraph}>
        Dox Scanner automatically detects document edges and helps create clean,
        professional scans.
      </p>

      <div style={styles.imageContainer}>
        <img
          src="/screenshot2.png"
          alt="Capture document using PDF scanner"
          style={styles.image}
        />
      </div>

      <h2 style={styles.heading}>Step 3 — Auto Crop & Enhance</h2>

      <p style={styles.paragraph}>
        After capturing the document, the app automatically crops unnecessary
        background areas and improves text clarity.
      </p>

      <p style={styles.paragraph}>
        This enhancement process helps scanned PDFs look more professional and
        easier to read.
      </p>

      <h2 style={styles.heading}>Step 4 — Convert Images to PDF</h2>

      <p style={styles.paragraph}>
        Once scanning is complete, save your scanned pages as high-quality PDF
        files directly on your iPhone.
      </p>

      <p style={styles.paragraph}>
        You can scan multiple pages and combine them into a single PDF document
        for easier sharing and organization.
      </p>

      <div style={styles.imageContainer}>
        <img
          src="/screenshot3.png"
          alt="Convert scanned images to PDF"
          style={styles.image}
        />
      </div>

      <h2 style={styles.heading}>Step 5 — Edit and Organize PDFs</h2>

      <p style={styles.paragraph}>
        Dox Scanner includes useful PDF editing tools that help users manage
        documents efficiently.
      </p>

      <ul style={styles.list}>
        <li>Rearrange PDF pages</li>
        <li>Merge multiple PDFs</li>
        <li>Split large documents</li>
        <li>Add text and annotations</li>
        <li>Protect PDFs with passwords</li>
      </ul>

      <h2 style={styles.heading}>
        Why Offline PDF Scanner Apps Are Better
      </h2>

      <p style={styles.paragraph}>
        Offline PDF scanner apps process files directly on the device without
        uploading documents to cloud servers. This improves privacy and ensures
        your files remain under your control.
      </p>

      <p style={styles.paragraph}>
        Offline scanning is especially useful in low-network areas where users
        may not always have stable internet access.
      </p>

      <ul style={styles.list}>
        <li>No internet required</li>
        <li>Better document privacy</li>
        <li>Faster scanning performance</li>
        <li>No cloud dependency</li>
        <li>Reliable access anywhere</li>
      </ul>

      <div style={styles.imageContainer}>
        <img
          src="/screenshot4.png"
          alt="Offline PDF scanner app"
          style={styles.image}
        />
      </div>

      <h2 style={styles.heading}>Final Thoughts</h2>

      <p style={styles.paragraph}>
        Scanning documents to PDF on iPhone is easier than ever with modern
        offline PDF scanner apps. Users now expect privacy-focused features,
        OCR support, PDF editing tools, and reliable offline functionality in a
        single application.
      </p>

      <p style={styles.paragraph}>
        Dox Scanner is built to provide a fast, secure, and professional
        document scanning experience without ads, unnecessary tracking, or cloud
        dependency.
      </p>

      <a
        href="https://apps.apple.com/app/id6761522255"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button
          style={{
            padding: "15px 34px",
            borderRadius: "10px",
            border: "none",
            background: "#000",
            color: "#fff",
            cursor: "pointer",
            marginTop: "30px",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          Download Dox Scanner
        </button>
      </a>
    </div>
  );
}

const styles = {
  heading: {
    fontSize: "30px",
    marginTop: "45px",
    marginBottom: "15px",
    fontWeight: "bold",
    color: "#111",
  },

  paragraph: {
    fontSize: "18px",
    color: "#555",
    marginBottom: "18px",
  },

  list: {
    paddingLeft: "25px",
    color: "#444",
    fontSize: "18px",
    marginBottom: "25px",
  },

  imageContainer: {
    display: "flex",
    justifyContent: "center",
    margin: "35px 0",
  },

  image: {
    width: "25%",
    height: "25%",
    borderRadius: "18px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
  },
};